<template>
  <div>
    <el-card class="elshadow mb-6 rounded-10px">
      <div class="flex items-center">
        <img
          src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/builder/ba.png"
          alt="image"
          class="avatar-imgw"
        />
        <div class="pl-2 flex justify-between items-center w-full">
          <h2 class="fsize16 text-black font-semibold">Schedule a call</h2>

          <!-- <button @click="signOff">sign Off</button> -->
          <vs-button
            v-if="!showDate"
            @click="signOff"
            variant="primary"
            class="font-semibold rounded-full fsize12 py-1 px-4 sm-fsize14 h-8"
          >
            Sign Off
          </vs-button>
          <div v-else class="">
            <p class="text-success mb-1 text-right">Signed Off</p>
            <p class="text-dark fsize12 mb-2">
              {{ new Date(allData.signOff_status.date).toDateString() }}
            </p>
          </div>
          <!-- <div>
            <img
              src="@/views/adminPanel/pages/builder/NewScreen/img/1.jpg"
              alt="image"
              class="w-6 h-6 rounded-full"
            />
            <img
              src="@/views/adminPanel/pages/builder/NewScreen/img/2.jpg"
              alt="image"
              class="w-6 h-6 rounded-full"
            />
            <img
              src="@/views/adminPanel/pages/builder/NewScreen/img/3.jpg"
              alt="image"
              class="w-6 h-6 rounded-full"
            />
          </div> -->
        </div>
      </div>

      <div class="mt-8">
        <!-- <h4 class="font-semibold fsize16 text-4f4f4f mb-2">Partner Details</h4>
        <p class="text-8f8f8f">Name : {{ partnerName }}</p>
        <p class="text-8f8f8f">Email : {{ partnerEmail }}</p>
        <p class="text-8f8f8f">Phone no : {{ partnerPhoneno }}</p> -->
        <h4 class="font-semibold fsize16 text-4f4f4f mb-2">Overview</h4>
        <p class="text-8f8f8f">
          The very first step for a successful project lifecycle is
          understanding more about you & your business needs. 
        </p>
        <p class="pt-1 text-8f8f8f">
          Project manager & team understand your requirements & propose a
          delivery plan.
        </p>
      </div>
    </el-card>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      showDate: false,
      allData: {},
      projectData: [],
    };
  },
  methods: {
    async signOff() {
      const payload = {
        _id: this.selectedSprint._id,
        signOff_status: {
          user: {
            name: this.login.name,
            email: this.login.email,
          },
          status: true,
        },
      };
      const data = await this.$store.dispatch("user/updateTaskList", payload);
      this.call();
    },

    async call() {
      const data = await this.$store.dispatch("user/getTaskList", {
        _id: this.selectedSprint._id,
        projectName: this.selectedProject.projectName,
      });
      if (data.data.data[0].signOff_status.status) {
        this.showDate = true;
      } else {
        this.showDate = false;
      }
      this.allData = data.data.data[0];
      console.log(this.allData);
    },
  },
  computed: {
    ...mapState("admin", ["login"]),
    ...mapState("design", ["selectedSprint"]),
    ...mapState("user", ["selectedProject"]),
  },
  mounted() {
    this.call();
  },
};
</script>
<style scoped>
.vs-collapse {
  padding: 0px !important;
  margin-bottom: 12px;
  font-size: 12px !important;
  border-radius: 4px;
}
</style>
